// Disable max class per file due to form validation classes
/* eslint-disable max-classes-per-file */

import { IsBoolean, IsOptional, IsInt, IsNotEmpty, IsString, ValidateNested, Min, Max } from 'class-validator';

export class SymbolForm {
  @IsInt()
  id: number;

  @IsString()
  @IsNotEmpty()
  name: string;
}

export class LineweightForm {
  @IsInt()
  id: number;

  @IsString()
  @IsNotEmpty()
  weight: number;
}

export class ColorBookForm {
  @IsInt()
  id: number;

  @IsString()
  @IsNotEmpty()
  name: string;
}

export class TemplateForm {
  @IsInt()
  id: number;

  @IsString()
  @IsNotEmpty()
  name: string;
}

export class PlotStyleForm {
  @IsInt()
  id: number;

  @IsString()
  name: string;
}

export class AutodeskLayerForm {
  @IsString()
  @IsNotEmpty()
  name: string;

  @IsString()
  @IsOptional()
  description: string | null;

  @IsNotEmpty()
  @IsInt()
  @Min(0)
  @Max(255)
  color: number;

  @IsBoolean()
  isPlot: boolean;

  @IsBoolean()
  isNewViewportFreeze: boolean;

  @IsInt()
  @Min(0)
  @Max(90)
  transparency: number;

  @ValidateNested()
  symbol: SymbolForm;

  @ValidateNested()
  lineweight: LineweightForm;

  @IsOptional()
  @ValidateNested()
  colorBook?: ColorBookForm | null;

  @ValidateNested()
  template: TemplateForm;

  @IsOptional()
  @ValidateNested()
  plotStyle?: PlotStyleForm;
}
